module.exports = __webpack_public_path__ + "img/3.fdc9cb86.png";